import React, { useMemo, useState, useRef, useImperativeHandle, forwardRef, useCallback, useEffect } from "react";
import { View,
  Text,
  TextInput,
  StyleSheet,
  TouchableOpacity,
  Image,
  Platform,
  ActivityIndicator
} from "react-native";
import { Trans, useTranslation } from 'react-i18next';
import GradientBackground from '../../../../uiComponents/GradientBackground';
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import { FeeLookupHelper } from "../../../../../helper/feeLookupHelper";
import EnglishFlag from "../../../../../../../../assets/images/english-flag.png";
import DownArrow from "../../../../../../../../assets/images/DownArrowIcon.svg";
import Colors from "../../../../../constants/colors";
import { ComponentStyles } from "../../../../../constants/componentStyles";
import { postFeeLookup } from "../../../../../services/common.service";
import type { FeeInfo } from "../../../../../view-models/feeInfo";
import {
  openMoneygramPrivacyPolicy,
  openMoneygramPrivacyPolicyUsEs,
  openMoneygramTermsAndConditions,
  openMoneygramTermsAndConditionsUsEs,
} from "../../../../../helper/moneygramLegalLinks";

import { Flag } from "../../../../Flag";
import { useGlobalError } from "../../../../uiComponents/GlobalErrorProvider";
// import { captureEvents } from '../../../../../utils/inputCapture';
import  FloatingTextInputComponent from "../../../common/FloatingTextInputComponent";
import PromocodeTextInputComponent from "../../../common/PromocodeTextInputComponent";

type Props = {
  onContinue: () => void;
  onEditStep?: (key: string) => void;
  handleApplyPromoCode?: () => void;
  updatePromocode: () => void;
  // onChangeText: (text: string) => void;
  clearPromoCode?: () => void;
  promoCode?: string;
  errorText?: string;
  /** API error from GetFieldsForProduct (e.g. invalid country/delivery selection); shown in the selection area */
  selectionError?: string;
  testID?: string | undefined;
  /** Web: parent uses this to move the gradient footer from fixed into the scroll while the user edits the promo field. */
  onWebEditableFocusChange?: (focused: boolean) => void;
};

export interface ReviewAndEditStepHandle {
  submit: () => Promise<boolean>;
}

const ReviewAndEditStep = forwardRef<ReviewAndEditStepHandle, Props>(({ onEditStep, handleApplyPromoCode, updatePromocode, clearPromoCode, promoCode, errorText, selectionError, testID, onWebEditableFocusChange }: Props, ref) => {
// export default function ReviewAndEditStep({ onEditStep, onContinue, handleApplyPromoCode }: Props, ref) {
  const { t, i18n } = useTranslation();
  const [pin, setPin] = useState(["", "", "", ""]);
  const inputs = useRef<(TextInput | null)[]>([]);
  const webBlurTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (webBlurTimerRef.current) {
        clearTimeout(webBlurTimerRef.current);
        webBlurTimerRef.current = null;
      }
    };
  }, []);

  const notifyWebEditableFocused = useCallback(() => {
    if (Platform.OS !== "web" || !onWebEditableFocusChange) return;
    if (webBlurTimerRef.current) {
      clearTimeout(webBlurTimerRef.current);
      webBlurTimerRef.current = null;
    }
    onWebEditableFocusChange(true);
  }, [onWebEditableFocusChange]);

  const scheduleWebEditableBlurred = useCallback(() => {
    if (Platform.OS !== "web" || !onWebEditableFocusChange) return;
    if (webBlurTimerRef.current) clearTimeout(webBlurTimerRef.current);
    webBlurTimerRef.current = setTimeout(() => {
      webBlurTimerRef.current = null;
      onWebEditableFocusChange(false);
    }, 200);
  }, [onWebEditableFocusChange]);
  // const [promoCode, setPromoCode] = useState("");
  // const [errors, setErrors] = useState({
  //       promoCode: "",
  //   });
  const [applyLoading, setApplyLoading] = useState<boolean>(false);
  const [preApplyFees, setPreApplyFees] = useState<number | null>(null);
  const [postApplyFees, setPostApplyFees] = useState<number | null>(null);
  const pendingSendOption = useSessionStore((s: SessionState) => (s as any).pendingSendOption);
  const selectedSendOption = useSessionStore((s: SessionState) => (s as any).selectedSendOption);
  const selectedCountryCode = useSessionStore((s: SessionState) => s.selectedDestinationCountryCode);
  const selectedCountryName = useSessionStore((s: SessionState) => s.selectedDestinationCountryName);
  const selectedStateName = useSessionStore((s: SessionState) => s.selectedDestinationStateName);
  const feeLookupParams = useSessionStore((s: SessionState) => (s as any).sendFeeLookupReviewEditStore);
  const setSendFeeLookupReviewEditStore = useSessionStore((s: SessionState) => (s as any).setSendFeeLookupReviewEditStore);
  const setLastFeeLookupResponse = useSessionStore((s: SessionState) => (s as any).setLastFeeLookupResponse);
  const setSelectedSendOptionStore = useSessionStore((s: SessionState) => (s as any).setSelectedSendOption);
  const setPendingSendOptionStore = useSessionStore((s: SessionState) => (s as any).setPendingSendOption);
  const lastFeeLookupResponse = useSessionStore((s: SessionState) => (s as any).lastFeeLookupResponse);
  const selectedDeliveryOptionStore = useSessionStore((s: SessionState) => (s as any).selectedDeliveryOptionStore);
  const isPromoActivityIndicator = useSessionStore((s: SessionState) => (s as any).isPromoActivityIndicator);
  const isPromocodeApplied = useSessionStore((s: SessionState) => (s as any).isPromocodeApplied);
  console.log('isPromocodeApplied==>', isPromoActivityIndicator, isPromocodeApplied)
  const { showError } = useGlobalError();

  // useImperativeHandle(ref, () => ({
  //       submit: async () => {
  //         const newErrors = {
  //           promoCode: promoCode.trim() ? "" : "Please enter valid promocode",
  //         };
  //         setErrors(newErrors);
      
  //         // if any error string is non-empty
  //         const isValid = !Object.values(newErrors).some(Boolean);
  //         return isValid;
  //       },
  //     }));

  const option: any = pendingSendOption || selectedSendOption || null;
  // Selected delivery option FeeInfo derived reactively from store
  const selectedDeliveryFeeInfo: FeeInfo | undefined = useMemo(() => {
    const arr: FeeInfo[] = Array.isArray((lastFeeLookupResponse as any)?.FeeInfos)
      ? (lastFeeLookupResponse as any).FeeInfos
      : (Array.isArray((lastFeeLookupResponse as any)?.FeeInfo) ? (lastFeeLookupResponse as any).FeeInfo : []);
    const sel = ((selectedDeliveryOptionStore as any)?.DeliveryOption ?? '').toString().toUpperCase();
    if (!arr || arr.length === 0) return undefined;
    if (!sel) return arr[0];
    return arr.find((f: any) => {
      const opt = (f?.DeliveryOption ?? f?.DeliveryOptId ?? '').toString().toUpperCase();
      return !!opt && opt === sel;
    }) || arr[0];
  }, [lastFeeLookupResponse, selectedDeliveryOptionStore]);
  const summary = useMemo(() => {
    if (!option) {
      return {
        sendAmount: 0,
        sendCurrency: 'USD',
        receiveAmount: 0,
        receiveCurrency: '—',
        exchangeRate: 0,
        fees: 0,
        total: 0,
      };
    }
    const sendCurrency: string = option?.SendAmounts?.SendCurrency || 'USD';
    const sendAmount: number = Number(option?.SendAmounts?.SendAmount || 0);
    const receiveCurrency: string = option?.ReceiveAmounts?.ValidCurrencyIndicator
      ? (option?.ValidReceiveCurrency || '')
      : (option?.EstimatedReceiveCurrency || option?.ValidReceiveCurrency || '');
    const receiveAmount: number = Number(option?.ValidReceiveAmount ?? option?.EstimatedReceiveAmount ?? 0);
    const exchangeRateNum: number = Number(FeeLookupHelper.getExchangeRate(option) || 0);
    const fees: number = Number(option?.SendAmounts?.TotalDiscountAmount || 0) + Number(option?.SendAmounts?.TotalSendFees || 0);
    const totalBase: number = Number(option?.TotalAmount || 0);
    const total: number = totalBase;
    return { sendAmount, sendCurrency, receiveAmount, receiveCurrency, exchangeRate: exchangeRateNum, fees, total };
  }, [pendingSendOption, selectedSendOption]);

  const termsAgreementLinkComponents = useMemo(
    () => ({
      termsLink: (
        <Text
          style={[styles.link, { textDecorationLine: "underline" }]}
          onPress={
            i18n.language.startsWith("es")
              ? openMoneygramTermsAndConditionsUsEs
              : openMoneygramTermsAndConditions
          }
          accessibilityRole="link"
        />
      ),
      privacyLink: (
        <Text
          style={[styles.link, { textDecorationLine: "underline" }]}
          onPress={
            i18n.language.startsWith("es")
              ? openMoneygramPrivacyPolicyUsEs
              : openMoneygramPrivacyPolicy
          }
          accessibilityRole="link"
        />
      ),
    }),
    [i18n.language]
  );

  const exchangeNoticeComponents = useMemo(
    () => ({
      bold: <Text style={styles.bold} />,
    }),
    []
  );

  console.log('pendingSendOption........', pendingSendOption);

  const handleChange = (text: string, index: number) => {
    if (/^\d*$/.test(text)) {
      const newPin = [...pin];
      newPin[index] = text;
      setPin(newPin);

      // Move to next box automatically
      if (text && index < 3) {
        inputs.current[index + 1]?.focus();
      }

      // Backspace handling
      if (!text && index > 0) {
        inputs.current[index - 1]?.focus();
      }
    }
  };

  // const handleApplyPromoCode = async() => {
  //   console.log('APPLYY PROMOOOO111', )
  //   setApplyLoading(true);
  //   setPreApplyFees(summary.fees);
  //   console.log('PREWAPPLY==>', summary.fees)
  //   try {
  //     const updatedParams = {
  //       ...(feeLookupParams || {}),
  //       promoCodes: promoCode ? [promoCode] : undefined,
  //       deliveryOption: ((selectedDeliveryOptionStore as any)?.DeliveryOption ?? undefined),
  //       allOptions: false,
  //     } as any;

  //     console.log('PREWAPPLY==>Inside try', summary.fees)
  //     try { setSendFeeLookupReviewEditStore?.(updatedParams); } catch {}

  //     const feeResp = await postFeeLookup(updatedParams as any);
  //     console.log('Promo code applied:', promoCode, 'feeLookupParams:', updatedParams, 'feeResp:', feeResp);

  //     // Normalize response
  //     const rawData: any = (feeResp && (feeResp as any).data !== undefined) ? (feeResp as any).data : feeResp;
  //     let parsed: any = rawData;
  //     if (typeof rawData === 'string') {
  //       try { parsed = JSON.parse(rawData); } catch {}
  //     }

  //     // Inspect potential error envelope in fee lookup response
  //     const errDetail = parsed?.ErrorDetail || parsed?.errorDetail;
  //     if (errDetail) {
  //       const errCode = errDetail?.ErrorCode ?? errDetail?.errorCode ?? 'UNKNOWN';
  //       const errString = errDetail?.ErrorString ?? errDetail?.errorString ?? 'An error occurred.';
  //       console.warn('FeeLookup ErrorDetail:', { errCode, errString });
  //       //showError(errCode + ' ' + errString);
        
  //       trackUIError(errCode + ' ' + errString, 'Promo Code Error');
  //       showError(t('ERROR_INVALID_PROMOCODE'));
  //       return;
  //     }

  //     try { setLastFeeLookupResponse?.(parsed); } catch {}

  //     const feeInfos: any[] = Array.isArray(parsed?.FeeInfos)
  //       ? parsed?.FeeInfos
  //       : (Array.isArray(parsed?.FeeInfo) ? parsed?.FeeInfo : []);

  //     // Try to find the updated option matching current selection
  //     const current = option || {};
  //     const match = feeInfos.find((f: any) => {
  //       const sameDisplay = (f?.DeliveryOptDisplayName || '') === (current?.DeliveryOptDisplayName || '');
  //       const sameAgent = (f?.ReceiveAgentId || f?.ReceiveAgentID) === (current?.ReceiveAgentId || current?.ReceiveAgentID);
  //       return sameDisplay || sameAgent;
  //     }) || feeInfos[0];

  //     if (!match) {
  //       return;
  //     }

  //     // Check promotion status
  //     const promoArray: any[] = Array.isArray(match?.PromotionInfo) ? match?.PromotionInfo : [];
  //     const hasError = promoArray.some((p: any) => !!(p?.PromotionErrorCode || p?.promotionErrorCode));
  //     if (!hasError) {
  //       // Apply discount to fees if necessary (prefer server-calculated values)
  //       const discountAmt = Number(match?.SendAmounts?.TotalDiscountAmount ?? 0)
  //         || Number(promoArray?.reduce((sum: number, p: any) => sum + Number(p?.PromotionDiscountAmount || 0), 0));
  //       const originalFees = Number(match?.SendAmounts?.TotalSendFees ?? 0);
  //       const taxes = Number(match?.SendAmounts?.TotalSendTaxes ?? 0);
  //       const sendAmt = Number(match?.SendAmounts?.SendAmount ?? 0);
  //       const discountedFees = Math.max(0, originalFees - (discountAmt || 0));

  //       const totalAmountToCollect = (typeof match?.SendAmounts?.TotalAmountToCollect === 'number')
  //         ? Number(match?.SendAmounts?.TotalAmountToCollect)
  //         : (sendAmt + discountedFees + taxes);

  //       const updatedOption = {
  //         ...match,
  //         SendAmounts: {
  //           ...(match?.SendAmounts || {}),
  //           TotalDiscountAmount: discountAmt || match?.SendAmounts?.TotalDiscountAmount,
  //           TotalSendFees: discountedFees,
  //           TotalAmountToCollect: totalAmountToCollect,
  //         },
  //         TotalAmount: typeof match?.TotalAmount === 'number' ? match?.TotalAmount : totalAmountToCollect,
  //       } as any;

  //       // Capture new fees (discount + discountedFees) for display
  //       try { setPostApplyFees((discountAmt || 0) + (discountedFees || 0)); } catch {}
  //       try { setSelectedSendOptionStore?.(updatedOption); } catch {}
  //       try { setPendingSendOptionStore?.(updatedOption); } catch {}
  //       console.log('APPLYY PROMOOOOLast postApplyFees', (discountAmt || 0) + (discountedFees || 0))
  //     }
  //     setApplyLoading(false);
  //     console.log('APPLYY PROMOOOOLast postApplyFees', postApplyFees)
  //   } catch (e: any) {
  //     setApplyLoading(false);
  //     console.warn('handleApplyPromoCode error:', e);
  //     try { showError(e?.message || 'An error occurred applying the promo code.'); } catch {}
  //   } finally {
  //     setApplyLoading(false);
  //   }
  // }

  return (
    <View style={styles.container} testID={testID}>
      <Text style={styles.title}>{t("REVIEW_TITLE")}</Text>
      {/* <Text style={styles.subtitle}>{t("REVIEW_SUBTITLE")}</Text> */}
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 24}}>
        <View>
          <Text style={[styles.inputLabel]}>{t("YOU_SEND")}</Text>
          <View style={styles.amountInput}>
            <Text style={styles.amountText}>{selectedDeliveryFeeInfo?.SendAmounts?.SendAmount?.toFixed(2)}</Text>
            <Text style={styles.currencyText}>{selectedDeliveryFeeInfo?.SendAmounts?.SendCurrency}</Text>
          </View>
          <Text style={[styles.inputLabel, {marginTop: 8}]}>{t("THEY_RECEIVE")}</Text>
          <View style={styles.amountInput}>
            <Text style={styles.amountText}>{summary.receiveAmount != null ? (typeof summary.receiveAmount === 'number' ? summary.receiveAmount.toFixed(2) : String(summary.receiveAmount)) : '—'}</Text>
            <Text style={styles.currencyText}>{summary.receiveCurrency || '—'}</Text>
          </View>
        </View>
        <TouchableOpacity testID="sendingAmountEntryButton"
          style={styles.editButton}
          onPress={() => onEditStep?.('sendingAmountEntry')}>
          <Text style={styles.editText}>{t("EDIT")}</Text>
        </TouchableOpacity>
      </View>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 32}}>
        <View>
          <Text style={[styles.inputLabel]}>{t("REVIEW_DESTINATION_COUNTRY")}</Text>
          <View style={[styles.amountInput, {alignItems: 'center'}]}>
            <Flag iso3={selectedCountryCode ?? ''} width={16} height={16} />
            <Text style={styles.CountryText}>{ selectedCountryName +' '+ '(' +selectedCountryCode+')'}</Text>
          </View>
        </View>
        <TouchableOpacity testID="countryButton"
          // style={{ backgroundColor: Colors.white, height: 30, width: 50, alignItems: 'flex-end', justifyContent: 'center'}}
          style={styles.editButton}
          onPress={() => onEditStep?.('country')}>
          <Text style={styles.editText}>{t("EDIT")}</Text>
          {/* <DownArrow width={20} height={20}/> */}
        </TouchableOpacity>
      </View>
      { (selectedCountryCode === 'USA' || selectedCountryCode === 'CAN') &&
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 32}}>
        <View>
          <Text style={[styles.inputLabel]}>{t("DESTINATION_STATE")}</Text>
          <Text style={[styles.CountryText, styles.stateValueText]}>{selectedStateName}</Text>
        </View>
        <View>
          <TouchableOpacity testID="stateButton"
            style={styles.editButton}
            onPress={() => onEditStep?.('state')}>
            <Text style={styles.editText}>{t("EDIT")}</Text>
          </TouchableOpacity>
        </View>
      </View>
      }
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 32, marginBottom: 24}}>
        <View style={styles.textContainer}>
          <Text style={[styles.inputLabel]}>{t("RECEIVE_METHOD_TITLE")}</Text>
          <Text style={[styles.pickUpText, { flexShrink: 1}]}>{selectedDeliveryFeeInfo?.DeliveryOptDisplayName}</Text>
        </View>
        <TouchableOpacity testID="howTheyReceiveButton"
          style={styles.editButton}
          onPress={() => onEditStep?.('howTheyReceive')}>
          <Text style={styles.editText}>{t("EDIT")}</Text>
        </TouchableOpacity>
      </View>
      {/* <View style={styles.promoContainer}>
        <TextInput 
          testID="promoCode"
          style={styles.promoInput}
          placeholder="Promo code"
          value={promoCode}
          onChangeText={setPromoCode}
        />
        <TouchableOpacity style={styles.promoApplyButton} testID="promoApplyButton"
          disabled={applyLoading}
          onPress={async () => {
            handleApplyPromoCode()
          }}
        >
          {applyLoading ? (
            <ActivityIndicator size="small" color={Colors.applyText} style={{ paddingVertical: 4, paddingHorizontal: 6 }} />
          ) : (
            <Text style={styles.applyText}>Apply</Text>
          )}
        </TouchableOpacity>
      </View> */}
      <PromocodeTextInputComponent
        testID="sendReviewAndEdit"
        label={t("PROMO_CODE")}
        value={promoCode}
        onChangeText={updatePromocode}
        clearPromoCode={clearPromoCode}
        handleApplyPromoCode={handleApplyPromoCode}
        activityIndicatorStatus={isPromoActivityIndicator}
        isPromocodeApplied={isPromocodeApplied}
        errorText={errorText}
        onFieldFocus={onWebEditableFocusChange ? notifyWebEditableFocused : undefined}
        onFieldBlur={onWebEditableFocusChange ? scheduleWebEditableBlurred : undefined}
      />
      {/* Terms */}
      {/* <View style={{ marginTop: 16 }}>
        <Text style={styles.terms}>
          I agree to MoneyGram’s <Text style={styles.link}>Terms and Conditions</Text> and confirm I am the sole beneficial owner of the assets, and am acting solely on my own profile. By continuing with this transaction I consent to the collection, use, disclosure, and transfer (including cross-border transfer) of my personal information as described in our <Text style={styles.link}>Privacy Policy.</Text>
        </Text>
        <Text style={[styles.terms, { marginTop: 16, marginBottom: 24}]}>
          <Text style={styles.bold}>Exchange rate</Text>{"\n"}
          In addition to transfer fees, a currency exchange rate, also determined by MoneyGram, may also apply. MoneyGram may also make money from currency exchange. When selecting a money transfer operator, carefully compare both transfer fees and currency exchange rates. Transfer fees may vary depending on the amount being transferred and the delivery method. Transfer fee and currency exchange rate may be subject to change by MoneyGram without notice.
        </Text>
      </View> */}
      <View style={{ marginTop: 16, marginBottom: 16 }}>
        <View>
          <Text style={styles.terms}>
            <Trans
              i18nKey="BILL_PAY_FINAL_TERMS_AGREEMENT"
              components={termsAgreementLinkComponents}
            />
          </Text>
          <Text style={[styles.terms, { marginTop: 16 }]}>
            <Trans
              i18nKey="BILL_PAY_FINAL_EXCHANGE_NOTICE"
              components={exchangeNoticeComponents}
            />
          </Text>
        </View>
      </View>
      {/* Fees and CTA */}
      {/* <GradientBackground style={styles.gradientCard}>
        <View style={styles.row}>
          <Text style={styles.feeLabel}>{t("EXHANGE_RATE")}</Text>
          <View style={{ flexDirection: 'row'}}>
            <Text style={styles.oldPrice}>1 {selectedDeliveryFeeInfo?.SendAmounts?.SendCurrency} = {summary.exchangeRate.toFixed(4)} {selectedDeliveryFeeInfo?.ReceiveAmounts?.ReceiveCurrency}</Text>
          </View>
        </View>
        <View style={styles.row}>
          <Text style={styles.feeLabel}>{t("FEES")}</Text>
          <View style={{ flexDirection: 'row', alignItems: 'baseline'}}>
            {(preApplyFees !== null && postApplyFees !== null && Number(preApplyFees.toFixed(2)) !== Number(postApplyFees.toFixed(2))) ? (
              <>
                <Text style={[styles.oldPrice, { textDecorationLine: 'line-through', marginRight: 8 }]}>{preApplyFees.toFixed(2)} {selectedDeliveryFeeInfo?.SendAmounts?.SendCurrency}</Text>
                <Text style={styles.newPrice}>{postApplyFees.toFixed(2)} {selectedDeliveryFeeInfo?.SendAmounts?.SendCurrency}</Text>
              </>
            ) : (
              <Text style={styles.oldPrice}>{summary.fees.toFixed(2)} {selectedDeliveryFeeInfo?.SendAmounts?.SendCurrency}</Text>
            )}
          </View>
        </View>
        <View style={styles.row}>
          <Text style={[styles.feeLabel, {textDecorationLine: "underline"}]}>{t("REVIEW_TOTAL")}</Text>
          <View style={{ flexDirection: 'row'}}>
            <Text style={styles.oldPrice}>{summary.total.toFixed(2)} {selectedDeliveryFeeInfo?.SendAmounts?.SendCurrency}</Text>
          </View>
        </View>
        <TouchableOpacity testID="continueButton" 
          onPress={onContinue}
          activeOpacity={0.8}
          style={styles.continueButton}
        >
          <Text style={styles.continueButtonText}>{t("STRKEY_CONTINUE")}</Text>
        </TouchableOpacity>
      </GradientBackground> */}
    </View>
  );
})

export default ReviewAndEditStep;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    justifyContent: "flex-start",
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: '500', 
    color: Colors.titleTextColor,
    lineHeight: 34,
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 24,
    color: Colors.subTitleColor,
  },
  textContainer: {
    flex: 1,
    flexShrink: 1,
    marginRight: 8,
  },
  inputGroup: {
    marginBottom: 20,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: '400',
    fontFamily: 'Rubik',
    color: Colors.subTitleColor,
    lineHeight: 22,
    alignSelf: 'stretch',
  },
    exchangeRate: {
    fontSize: 16,
    color: '#4CAF50',
    fontWeight: '500',
  },
  amountInput: {
    flexDirection: 'row',
    alignItems: 'baseline',
    lineHeight: 36
  },
  pickUpText: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: '400',
    color: Colors.black,
    lineHeight: 20
  },
  amountText: {
    fontFamily: 'Rubik',
    fontSize: 32,
    fontWeight: '500',
    color: Colors.modalTitle,
    lineHeight: 36
  },
  amountTextGreen: {
    color: '#4CAF50',
  },
  currencyText: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: '500',
    color: Colors.subTitleColor,
    lineHeight: 24,
    paddingLeft: 8
  },
  editButton: {
    backgroundColor: Colors.searchBackground,
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 14
  },
  editText: {
    fontFamily: 'Rubik',
    fontSize: 14,
    fontWeight: '500',
    color: Colors.modalTitle,
    lineHeight: 16
  },
  CountryText: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: '400',
    color: Colors.titleTextColor,
    lineHeight: 24,
    marginLeft: 8
  },
  /** State row has no flag — `CountryText` margin is for spacing after the flag only. */
  stateValueText: {
    marginLeft: 0,
  },
  readOnlyInput: {
    backgroundColor: '#fafafa',
  },
  pinContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  pinInput: {
    width: 60,
    height: 60,
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 12,
    textAlign: "center",
    fontSize: 22,
    fontWeight: "600",
    backgroundColor: "#F9FAFB",
    marginRight: 24
  },
  error: {
    color: "red",
    fontSize: 12,
    marginTop: 8,
  },
  gradientCard: {
    alignItems: "center",
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    position: "absolute",
    right: 0,
    left: 0,
    top: "100%",
    transform: [{ translateX: -10 }],
  },
  promoApplyButton: {
    position: "absolute",
    right: 10,
    top: "45%",
    transform: [{ translateY: -10 }],
    borderWidth: 1,
    borderRadius: 8,
    borderColor: Colors.applyText,
    backgroundColor: Colors.white,
    width: 70,
    height: 32,
    alignItems: 'center',
    justifyContent: 'center'
  },
  viewTap: {
    height: 4,
    width: 77,
    backgroundColor: Colors.titleTextColor,
    borderRadius:24,
    marginBottom: 24,
    alignSelf: 'center'
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 16,
  },
  feeLabel: {
    fontSize: 16,
    fontWeight: "500",
  },
  oldPrice: {
    fontSize: 16,
    // textDecorationLine: "line-through",
    marginRight: 8,
  },
  newPrice: {
    fontSize: 16,
    fontWeight: "bold",
    color: "green",
  },
  button: {
    backgroundColor: "black",
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 24,
    // marginHorizontal: 30,
    width: '100%',
    alignItems: 'center',
    marginBottom: 12,
  },
  buttonText: {
    color: "white",
    fontWeight: "bold",
    fontSize: 16,
  },
  terms: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 16,
    color: Colors.subTitleColor,
  },
  link: {
    color: Colors.titleTextColor,
    fontWeight: "500",
  },
  promoContainer: {
    flexDirection: 'row',
    height: 56,
    padding: 24,
    borderRadius: 8,
    backgroundColor: Colors.searchCompanyBackground,
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 24
  },
  promoInput: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderRadius: 8,
    borderColor: '#B3B3B3',
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginRight: 12
  },
  applyText: {
    fontFamily: 'Rubik',
    fontSize: 14,
    fontWeight: '400',
    color: Colors.applyText,
    lineHeight: 18,
    paddingVertical: 4,
    paddingHorizontal: 6,
  },
  bold: { fontWeight: "600" },
  continueButton: {
    alignSelf: "center",
    backgroundColor: Colors.black,
    borderRadius: 8,
    paddingVertical: 16,
    alignItems: "center",
    shadowColor: Colors.black,
  },
  continueButtonText: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: "500",
    color: Colors.white,
    lineHeight: 24
  },
});
